import { siteGradients } from "./gradients";

export default {
  name: "Nye's Services",
  siteId: "nyes-services",
  domain: "nyesservices.co.uk", // Used for generating support email
  businessType: "hosting", // Defines legal content and features
  tagline: "Web Hosting & Development",
  gradients: siteGradients, // Site-specific gradients
  branding: {
    logo: {
      light: "/images/brand/nyes-services-logo.png",
      dark: "/images/brand/nyes-services-logo.png",
    },
  },
  navigation: {
    main: [
      { to: "/", label: "Home" },
      { to: "/contact", label: "Contact" },
    ],
    footer: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
    ],
  },
  social: [
    // Add your social media links here
    // Example: { href: 'https://twitter.com/heartfeltai', icon: 'Twitter', label: 'Twitter' },
  ],
  features: {
    app: {
      enabled: true,
      type: "web", // or 'mobile'
    },
    blog: false,
    newsletter: false,
    earlyAccess: false,
  },
  copyright: {
    content: "Nye's Services",
    developer: "Nye",
  },
  // Animation configuration
  animations: {
    enabled: true, // Master toggle for all animations
    pageTransitions: true, // Enable/disable page transitions
    componentAnimations: true, // Enable/disable component animations
    duration: 0.4, // Default animation duration in seconds
    easing: "easeInOut", // Default easing function
    defaultPageTransition: "fade", // Default page transition type
  },
  theme: {
    colors: {
      // Professional Blue-Gray Brand Colors
      primary: {
        // Professional Blue - Trust, reliability, technology
        // Used for: primary actions, links, brand elements
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6", // Main brand blue
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
      },
      secondary: {
        // Neutral Gray - Professional, clean, modern
        // Used for: text, secondary elements, borders
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b", // Main gray
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
      },
      accent: {
        // Soft Cyan - Highlight, accent, interactive elements
        // Used for: hover states, highlights, accents
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4", // Main accent cyan
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
      },
    },
  },
};
